import { useQuery } from '@tanstack/react-query';
import { fetchUser } from '../data/query.js';
import { useMenuAxios } from '../context/axios.js';

const useUserQuery = () => {
  const {
    instance
  } = useMenuAxios();
  return useQuery({
    queryKey: ["user"],
    queryFn: () => fetchUser(instance)
  });
};

export { useUserQuery };
